export const DEFAULT_GEO_LOCATION = { lat: 0, lon: 0 };

/**
 * **convertLatToTopPosition**_(lat)_<br>
 * Converts a latitude value to a top position value.
 * @param { Number } lat: The latitude value.
 * @returns { String } The latitude in top position value.
 */
export const convertLatToTopPosition = (lat: string | number) => {
  const latNumber = typeof lat === 'number' ? lat : parseFloat(lat);
  const yAxis = (90 - latNumber) / 180;
  return `${yAxis * 100}%`;
};

/**
 * **convertTopPositionToLat**_(topPosition)_<br>
 * Converts a top position value to latitude.
 * @param { Number } topPosition: The top position value in percent.
 * @returns { String } The latitude value.
 */
export const convertTopPositionToLat = (topPosition: number) => {
  const topDecimal = topPosition / 100;
  const yAxis = topDecimal * 180;
  return parseFloat(`${90 - yAxis}`).toFixed(2);
};

/**
 * **convertLonToLeftPosition**_(lon)_<br>
 * Converts a longitude value to a left position value.
 * @param { Number } lon: The longitude value.
 * @returns { String } The longitude in left position value.
 */
export const convertLonToLeftPosition = (lon: string | number) => {
  const lonNumber = typeof lon === 'number' ? lon : parseFloat(lon);
  const xAxis = (180 + lonNumber) / 360;
  return `${xAxis * 100}%`;
};

/**
 * **convertLeftPositionToLon**_(topPosition)_<br>
 * Converts a left position value to longitude.
 * @param { Number } leftPosition: The left position value in percent.
 * @returns { String } The longitude value.
 */
export const convertLeftPositionToLon = (leftPosition: number) => {
  const leftDecimal = leftPosition / 100;
  const xAxis = leftDecimal * 360;
  return parseFloat(`${(180 - xAxis) * -1}`).toFixed(2);
};

/**
 * **convertLatLonToPosition**_(topPosition)_<br>
 * Converts a latitude and longitude value to positions.
 * @param { Number } lat: The latitude value.
 * @param { Number } lon: The longitude value.
 * @returns { Object } Object containing lat and lon positions.
 */
export const convertLatLonToPosition = (lat: number, lon: number) => {
  const top = convertLatToTopPosition(lat);
  const left = convertLonToLeftPosition(lon);
  return { lat: top, lon: left, long: left, left };
};
